import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const Tenant = React.lazy(() =>
    import('../Tenant')
);

const TenantDetail = React.lazy(() =>
    import('../TenantDetail')
);

const tenantRoutesRegistry = [
    {
        path: PAGE_URL.TENANT_PAGE,
        element: <Tenant />,
        loading: <Loading />,
        layout: AdminLayout,
    },
    {
        path: `${PAGE_URL.TENANT_PAGE}/:id`,
        element: <TenantDetail />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default tenantRoutesRegistry;
